import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  headers:HttpHeaders = new HttpHeaders({});

  constructor(public http: HttpClient, public cookieService:CookieService) { 
    
  }

  loginGuest(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/sign-in`, data, {headers: this.headers})
  }

  loginMobile(data:any){
    // Diferencia del loginGuest es el device_id
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/sign-in`, data, {headers: this.headers})
  }
  
  registerMobile(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/register`, data, {headers: this.headers})
  }

  confirmCode(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/confirm`, data, {headers: this.headers})
  }

  loginWeb(data:any){
    // Es iugal a la loginGuest hasta los parametros
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/sign-in`, data, {headers: this.headers})
  }

  logout(){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/auth/logout`, {}, {headers: this.headers})
  }

  createAddress(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/users/address/create`, data, {headers: this.headers})
  }

  updateAddress(data:any, id: number){
    this.setHeaders()
    return this.http.patch<any>(`${environment.usersApiUrl}/api/v1/users/address/update/${id}`, data, {headers: this.headers})
  }

  updateProfile(data:any){
    this.setHeaders()
    return this.http.patch<any>(`${environment.usersApiUrl}/api/v1/auth/updateProfile`, data, {headers: this.headers})
  }

  me(){
    this.setHeaders()
    return this.http.get<any>(`${environment.usersApiUrl}/api/v1/auth/me`, {headers: this.headers})
  }

  getLocalitiesByZipCode(zip_code:string){
    this.setHeaders()
    return this.http.get<any>(`${environment.usersApiUrl}/api/v1/users/address/localities/${zip_code}`, {headers: this.headers})
  }

  getAddress(){
    this.setHeaders()
    return this.http.get<any>(`${environment.usersApiUrl}/api/v1/users/address/get`, {headers: this.headers})
  }

  createPaymentIntentLegacy(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/payments/getPaymentSheet`, data, {headers: this.headers})
  }

  getPaymentInfoLegacy(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/payments/getPaymentInfoMobile`, data, {headers: this.headers})
  }

  createPaymentIntent(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/payments/getPaymentSheet2`, data, {headers: this.headers})
  }

  getPaymentInfo(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/payments/getPaymentInfoMobile2`, data, {headers: this.headers})
  }

  getFare(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/shippings/getFare`, data, {headers: this.headers})
  }

  createOrder(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/shippings/createOrder`, data, {headers: this.headers})
  }

  getOrderStatus(data:any){
    this.setHeaders()
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/shippings/getOrderStatus`, data, {headers: this.headers})
  }

  getFamiliarPositions() {
    this.setHeaders();
    return this.http.get<any>(`${environment.usersApiUrl}/api/v1/users/familiars/get`, { headers: this.headers });
  }

  createFamiliarPosition(data: any) {
    this.setHeaders();
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/users/familiars/create`, data, { headers: this.headers });
  }

  updateFamiliarPosition(id: number, data: any) {
    this.setHeaders();
    return this.http.patch<any>(`${environment.usersApiUrl}/api/v1/users/familiars/update/${id}`, data, { headers: this.headers });
  }

  deleteFamiliarPosition(id: number) {
    this.setHeaders();
    return this.http.delete<any>(`${environment.usersApiUrl}/api/v1/users/familiars/delete/${id}`, { headers: this.headers });
  }

  getUserFamiliars() {
    this.setHeaders();
    return this.http.get<any>(`${environment.usersApiUrl}/api/v1/users/user_familiars/get`, { headers: this.headers });
  }

  createUserFamiliar(data: any) {
    this.setHeaders();
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/users/user_familiars/create`, data, { headers: this.headers });
  }

  updateUserFamiliar(data: any) {
    this.setHeaders();
    return this.http.patch<any>(`${environment.usersApiUrl}/api/v1/users/user_familiars/update`, data, { headers: this.headers });
  }

  deleteUserFamiliar(data: any) {
    this.setHeaders();
    return this.http.request<any>('delete', `${environment.usersApiUrl}/api/v1/users/user_familiars/delete`, { headers: this.headers, body: data});
  }

  deleteAddress(id: number) {
    this.setHeaders();
    return this.http.delete<any>(`${environment.usersApiUrl}/api/v1/users/address/delete/${id}`, { headers: this.headers });
  }

  sendTemporalPassword(data: any) {
    this.setHeaders();
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/users/setPassword`, data, { headers: this.headers });
  }

  changePassword(data: any) {
    this.setHeaders();
    return this.http.put<any>(`${environment.usersApiUrl}/api/v1/users/passwords/change-my-password`, data, { headers: this.headers });
  }

  resendConfirmationCode(data: any) {
    this.setHeaders();
    return this.http.post<any>(`${environment.usersApiUrl}/api/v1/users/resendCode`, data, { headers: this.headers });
  }

  deleteAccount(user_id:Number){
    this.setHeaders();
    return this.http.delete<any>(`${environment.usersApiUrl}/api/v1/users/users/delete/${user_id}`, { headers: this.headers });
  }
  
  setHeaders() {
    if (this.cookieService.check('UL')) {
      const token = this.cookieService.get('UL');

      this.headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      });
    }
    else if (this.cookieService.check('TokenU')) {
      const token = this.cookieService.get('TokenU');

      this.headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      });
    }
    else {
      this.headers = new HttpHeaders({
        'Accept': 'application/json',
      });
    }
  }
}
